import { useMemo } from "react";
import { useSelector } from "react-redux";
import { usePermissions } from "./usePermissions";
import { useScopedCustomers } from "./useScopedCustomers";
import { scopeOrders } from "../../functions/permissions";

/**
 * De orders (store `orders`) beperkt tot de scope van de ingelogde gebruiker
 * (zie useScopedCustomers). Zonder beperking dezelfde array als in de store.
 */
export const useScopedOrders = () => {
  const orders = useSelector((state) => state.firestoreReducer.ordered.orders);
  const { scope } = usePermissions();
  const customers = useScopedCustomers();
  return useMemo(() => scopeOrders(orders, scope, customers), [orders, scope, customers]);
};

export default useScopedOrders;
